import React, {useEffect, useRef} from 'react'
import Stack from '@mui/material/Stack';

import Item from './Item.js';
import { useSelector } from 'react-redux';

const SelectYesNo = ({onSelect, selected}) => {
    return (
            <Stack  spacing={2} alignItems="center">
                <Item selected={selected} onSelect={onSelect} value={`Oui`} id={1}/>
                <Item selected={selected} onSelect={onSelect} value={`Non`} id={0}/>
            </Stack>
    )
}

export default SelectYesNo